export default "__VITE_ASSET__B1gcpB4j__"